<script>
  import { navigate } from "svelte-routing";
  import { _ as t } from "svelte-i18n";
  import { Button } from "t2c-components";

  const handleBack = () => {
    navigate("/");
  };
</script>

<div class="container">
  <section class="wrapper">
    <div class="box" style="overflow: scroll; height: 45vh">
      <h1>{$t("notfound")}</h1>
      <Button on:click={handleBack}>{$t("backmain")}</Button>
    </div>
  </section>
</div>

<style>
  .container {
    width: 100%;
    font-weight: 400;
  }

  .wrapper {
    margin: 0 auto;
    max-width: 1020px;
  }

  .box {
    padding-top: 48px;
  }

  h1 {
    font-weight: 100;
    margin: 2rem 0;
  }
</style>
